import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import Moment from 'moment';

import { FaBusinessTime } from 'react-icons/fa';
import { FaUserAlt } from 'react-icons/fa';
import { IoIosNotifications } from 'react-icons/io';
import { HiMenu } from 'react-icons/hi';
import { VscGraph } from 'react-icons/vsc';
import { FaCartPlus, FaShoppingCart } from 'react-icons/fa';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
// import { IoMdChatboxes } from 'react-icons/io';
// import { IoMdClose } from 'react-icons/io';
import { FaCalendarAlt, FaCalendarDay, FaCalendar } from 'react-icons/fa';
import { FaRegClock } from 'react-icons/fa';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { FaHubspot } from 'react-icons/fa';
import { FaListOl } from 'react-icons/fa';
import { FaThList } from 'react-icons/fa';
import { FaSun } from 'react-icons/fa';
import { FaMoon } from 'react-icons/fa';
import { BiSupport } from 'react-icons/bi';
import { GoGraph } from 'react-icons/go';
import { FaSync } from 'react-icons/fa';
import { FaBoxes } from 'react-icons/fa';
import { FaList } from 'react-icons/fa';
import { FiMonitor } from 'react-icons/fi';

import { GiCrystalBall } from 'react-icons/gi';

import { useAuth } from '~/hooks/authentication';
import { useNotifications } from '~/hooks/notifications';
import { useMenu } from '~/hooks/menu';
// import { useIAmode } from '~/hooks/iamode';
import useAppTheme from '~/hooks/theme';

import api from '~/services/api';

import logoCPLight from '~/assets/logo-light.png';
import logoCPDark from '~/assets/logo-dark.png';

import {
  Container,
  Mobile,
  Content,
  Header,
  Ic,
  Information,
  Opts,
  Opt,
  Footer,
  NotificationCount,
  LogoClient,
  CollapseMenu,
  GlobalAreaVisible,
  AppName,
  ThemeBtn,
  ICAbc,
  CacheTime,
} from './styles';

import Loading from '../Loading';
import Submenu from '../Submenu';

import CachetimeType from '~/@types/cachetime';

let lang = require('moment/locale/pt-br');
Moment.locale('pt-br', lang);

const Menu: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);

  const { colors } = useTheme();

  const { currentTheme, toggleTheme } = useAppTheme();

  const history = useHistory();
  const location = useLocation();

  // const { enable, toggleIAmode } = useIAmode();

  const { user, signOut } = useAuth();
  const { total } = useNotifications();
  const { visible: globalVisible, toggleVisible } = useMenu();

  const [mobileMenuStatus, setMobileMenuStatus] = useState(false);

  const [inLoad, setInLoad] = useState(false);
  const [cachetime, setCachetime] = useState<CachetimeType | null>(null);

  const handlerMobileMenuVisibility = () => {
    setMobileMenuStatus(!mobileMenuStatus);
  };

  const handlerCheckPage = (page: string): boolean => {
    const data = location.pathname.split('/');
    return data[1] === page ? true : false;
  };

  const handlerChangePage = (page: string): void => {
    history.push(`${page}`);
    setMobileMenuStatus(false);
  };

  const goToAllNotifications = () => {
    history.push(`avisos`);
  };

  const handleClickOutside = useCallback(
    (event: Event): void => {
      if (
        ref.current &&
        ref.current.contains(event.target as Node) &&
        !globalVisible
      ) {
        toggleVisible();
      }
    },
    [globalVisible, toggleVisible],
  );

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  useEffect(() => {
    const fetchCachetime = async () => {
      try {
        setInLoad(true);

        setCachetime(null);

        const response = await api.get(`analise-de-produtos/cache-time`);

        const { data } = response;

        setCachetime(data);

        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };
    fetchCachetime();
  }, []);

  return (
    <Container
      ref={ref}
      className={`${globalVisible ? 'menu-opened' : 'menu-closed'} ${
        mobileMenuStatus ? 'mobile-show' : 'mobile-hide'
      }`}
    >
      <Mobile>
        <div>
          <img
            src={currentTheme === 'light' ? logoCPLight : logoCPDark}
            alt="Commerceplus"
            title="2.3"
            height={'20px'}
          />
          <h1>App Gestor</h1>
        </div>

        <ThemeBtn onClick={toggleTheme}>
          {currentTheme === 'dark' ? (
            <FaSun size={18} color={colors.IC1} />
          ) : (
            <FaMoon size={18} color={colors.IC1} />
          )}
        </ThemeBtn>

        {/* {!enable ? (
          <button onClick={toggleIAmode}>
            {enable ? (
              <IoMdClose size={26} color={colors.IC1} />
            ) : (
              <IoMdChatboxes size={26} color={colors.IC1} />
            )}
          </button>
        ) : null} */}

        <button type="button">
          <HiMenu
            size={26}
            color={colors.IC1}
            onClick={handlerMobileMenuVisibility}
          />
        </button>
      </Mobile>
      <Content
        className={mobileMenuStatus ? 'menu-mobile-show' : 'menu-mobile-hide'}
      >
        <CollapseMenu>
          <button
            onClick={toggleVisible}
            title={globalVisible ? 'Fechar menu' : 'Abrir menu'}
          >
            {globalVisible ? (
              <FaArrowLeft size={22} color={colors.IC1} />
            ) : (
              <FaArrowRight size={22} color={colors.IC1} />
            )}
          </button>
        </CollapseMenu>

        {globalVisible ? (
          <GlobalAreaVisible>
            <>
              <LogoClient onClick={() => handlerChangePage(`/dashboard`)}>
                <img
                  src={currentTheme === 'light' ? logoCPLight : logoCPDark}
                  title="Commerceplus - Dashboard"
                  alt="Commerceplus - Dashboard"
                />
              </LogoClient>

              <AppName>APP GESTOR</AppName>

              <Header>
                <Ic>
                  <FaUserAlt size={22} color={colors.IC2} />
                </Ic>

                <Information>
                  <h1>{user.identificadorloja}</h1>
                  <button type="button" onClick={signOut}>
                    Sair
                  </button>
                </Information>

                <ThemeBtn className="theme-btn" onClick={toggleTheme}>
                  {currentTheme === 'dark' ? (
                    <FaSun size={18} color={colors.IC1} />
                  ) : (
                    <FaMoon size={18} color={colors.IC1} />
                  )}
                </ThemeBtn>

                <NotificationCount onClick={goToAllNotifications}>
                  <IoIosNotifications size={32} color={colors.IC1} />
                  <strong>{total}</strong>
                </NotificationCount>
              </Header>

              <Opts>
                <Opt
                  active={handlerCheckPage(`dashboard`) || handlerCheckPage(``)}
                  onClick={() => handlerChangePage(`/dashboard`)}
                >
                  <i>
                    <VscGraph size={16} color={colors.IC1} />
                  </i>
                  <span>Dashboard</span>
                </Opt>

                <Opt
                  active={
                    handlerCheckPage(`pedidos`) || handlerCheckPage(`pedido`)
                  }
                  onClick={() => handlerChangePage(`/pedidos`)}
                >
                  <i>
                    <FaShoppingCart size={16} color={colors.IC1} />
                  </i>
                  <span>Pedidos</span>
                </Opt>

                <Submenu
                  icon={<GoGraph size={16} color={colors.IC1} />}
                  title="Estatísticas de Vendas"
                >
                  <>
                    <Opt
                      isSub
                      active={handlerCheckPage(`vendas-anuais`)}
                      onClick={() => handlerChangePage(`/vendas-anuais`)}
                    >
                      <i>
                        <FaCalendar size={16} color={colors.IC1} />
                      </i>
                      <span>Vendas Anuais</span>
                    </Opt>

                    <Opt
                      isSub
                      active={handlerCheckPage(`vendas-mensais`)}
                      onClick={() => handlerChangePage(`/vendas-mensais`)}
                    >
                      <i>
                        <FaCalendarAlt size={16} color={colors.IC1} />
                      </i>
                      <span>Vendas Mensais</span>
                    </Opt>

                    <Opt
                      isSub
                      active={handlerCheckPage(`vendas-diarias`)}
                      onClick={() => handlerChangePage(`/vendas-diarias`)}
                    >
                      <i>
                        <FaCalendarDay size={16} color={colors.IC1} />
                      </i>
                      <span>Vendas Diárias</span>
                    </Opt>

                    <Opt
                      isSub
                      active={handlerCheckPage(`vendas-por-horario`)}
                      onClick={() => handlerChangePage(`/vendas-por-horario`)}
                    >
                      <i>
                        <FaRegClock size={16} color={colors.IC1} />
                      </i>
                      <span>Vendas por Horário</span>
                    </Opt>

                    <Opt
                      isSub
                      active={handlerCheckPage(`vendas-por-estado`)}
                      onClick={() => handlerChangePage(`/vendas-por-estado`)}
                    >
                      <i>
                        <FaMapMarkerAlt size={16} color={colors.IC1} />
                      </i>
                      <span>Vendas por Estado</span>
                    </Opt>

                    <Opt
                      isSub
                      active={handlerCheckPage(`vendas-por-canal`)}
                      onClick={() => handlerChangePage(`/vendas-por-canal`)}
                    >
                      <i>
                        <FaHubspot size={16} color={colors.IC1} />
                      </i>
                      <span>Vendas por Canal</span>
                    </Opt>

                    <Opt
                      isSub
                      active={handlerCheckPage(`top-produtos`)}
                      onClick={() => handlerChangePage(`/top-produtos`)}
                    >
                      <i>
                        <FaListOl size={16} color={colors.IC1} />
                      </i>
                      <span>Top Produtos</span>
                    </Opt>

                    <Opt
                      isSub
                      active={handlerCheckPage(`vendas-por-categoria`)}
                      onClick={() => handlerChangePage(`/vendas-por-categoria`)}
                    >
                      <i>
                        <FaThList size={16} color={colors.IC1} />
                      </i>
                      <span>Vendas por Categoria</span>
                    </Opt>
                  </>
                </Submenu>

                <Submenu
                  icon={<FaBoxes size={16} color={colors.IC1} />}
                  title="Análise de Produtos"
                >
                  <>
                    {cachetime ? (
                      <CacheTime>
                        <FaBusinessTime size={20} color={colors.IC1} />
                        <div>
                          <p className="info1">
                            Período:{' '}
                            <b>{`${cachetime.periodoanalisedias} Dias`}</b>
                          </p>
                          <p className="info2">
                            Ultima atualização: {cachetime.dtgeracao}
                          </p>
                          <p
                            className="info3"
                            title={`Dados gerados ${Moment(
                              cachetime.ts,
                            ).fromNow()}`}
                          >
                            {Moment(cachetime.ts).fromNow()}
                          </p>
                        </div>
                      </CacheTime>
                    ) : null}

                    {inLoad ? (
                      <CacheTime>
                        <Loading color={colors.IC1} size={42} />
                      </CacheTime>
                    ) : null}

                    <Opt
                      isSub
                      active={handlerCheckPage(`painel`)}
                      onClick={() => handlerChangePage(`/painel`)}
                    >
                      <i>
                        <FiMonitor size={16} color={colors.IC1} />
                      </i>
                      <span>Painel</span>
                    </Opt>
                    <Opt
                      isSub
                      active={handlerCheckPage(`curva-abc`)}
                      onClick={() => handlerChangePage(`/curva-abc`)}
                    >
                      <i>
                        <ICAbc className="ic-custom">ABC</ICAbc>
                      </i>
                      <span>Curva ABC</span>
                    </Opt>
                    <Opt
                      isSub
                      active={handlerCheckPage(`estoque-preditivo`)}
                      onClick={() => handlerChangePage(`/estoque-preditivo`)}
                    >
                      <i>
                        <GiCrystalBall size={16} color={colors.IC1} />
                      </i>
                      <span>Estoque Preditivo</span>
                    </Opt>
                    <Opt
                      isSub
                      active={handlerCheckPage(`gestao-de-giro`)}
                      onClick={() => handlerChangePage(`/gestao-de-giro`)}
                    >
                      <i>
                        <FaSync size={16} color={colors.IC1} />
                      </i>
                      <span>Gestão de Giro</span>
                    </Opt>
                    <Opt
                      isSub
                      active={handlerCheckPage(`ranking`)}
                      onClick={() => handlerChangePage(`/ranking`)}
                    >
                      <i>
                        <FaList size={16} color={colors.IC1} />
                      </i>
                      <span>Ranking</span>
                    </Opt>
                    <Opt
                      isSub
                      active={handlerCheckPage(`sugestao-de-compras`)}
                      onClick={() => handlerChangePage(`/sugestao-de-compras`)}
                    >
                      <i>
                        <FaCartPlus size={16} color={colors.IC1} />
                      </i>
                      <span>Sugestão de Compras</span>
                    </Opt>
                  </>
                </Submenu>
              </Opts>

              <Footer>
                <a
                  href="https://base.commerceplus.com.br/external/manual/manuais-para-clientes/article/explicando-a-dashboard?p=a01a525a88d4d6f571a69d010cce4d3d2766bdb2941d0d365a408fda3a7eb6cd"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Precisa de Ajuda?"
                >
                  <i>
                    <BiSupport size={18} color={colors.ORANGE} />
                  </i>
                  <div>
                    <span>Precisa de ajuda?</span>
                    <small>Clique aqui e acesse o link</small>
                  </div>
                </a>
                <h5 title="Dúvidas e Problemas, reporte em nosso suporte!">
                  Versão: 0.0.1
                </h5>
              </Footer>
            </>
          </GlobalAreaVisible>
        ) : null}
      </Content>
    </Container>
  );
};

export default Menu;
